import DOMPurify from 'dompurify'
import { memoize } from 'lodash'
import LRUCache from 'lru-cache'

/**
 * After sanitizing callback.
 * - Add target back to links if present, and include rel attr.
 */
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if ('target' in node) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener')
  }
})

function sanitizeHtmlRaw(htmlString: string) {
  return DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true, svg: true } })
}

function sanitizeHtmlAndSvgRaw(htmlString: string) {
  return DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true, svg: true } })
}

// allow up to 50,000 unique cell contents before expiring
const maxEntries = 50000

export const sanitizeHtml = memoize(sanitizeHtmlRaw)
sanitizeHtml.cache = new LRUCache({ max: maxEntries })

export const sanitizeHtmlAndSvg = memoize(sanitizeHtmlAndSvgRaw)
sanitizeHtml.cache = new LRUCache({ max: maxEntries })
